import { FETCH_OCPI_PARTNER_PRICING, DELETE_OCPI_PARTNER_PRICING, UPDATE_OCPI_PARTNER_PRICING, CREATE_OCPI_PARTNER_PRICING, GET_OCPI_PARTNER_PRICING } from 'actions/ocpiPartnerPricing';
import { toast } from 'react-toastify';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  ocpiPartnerPricing: [],
  ocpiPartnerPricingDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const ocpiPartnerPricingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_OCPI_PARTNER_PRICING.REQUEST:
    case DELETE_OCPI_PARTNER_PRICING.REQUEST:
    case FETCH_OCPI_PARTNER_PRICING.REQUEST:
    case CREATE_OCPI_PARTNER_PRICING.REQUEST:
    case GET_OCPI_PARTNER_PRICING.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_OCPI_PARTNER_PRICING.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ocpiPartnerPricing: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_OCPI_PARTNER_PRICING.SUCCESS: {
      return {
        ...state,
        ocpiPartnerPricingDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_OCPI_PARTNER_PRICING.SUCCESS: {
      toast.success('OCPI Partner Pricing added successfully');
      return {
        ...state,
        ocpiPartnerPricing: _.concat(state.ocpiPartnerPricing, payload),
        isLoading: false,
      };
    }

    case UPDATE_OCPI_PARTNER_PRICING.SUCCESS: {
      toast.success('OCPI Partner Pricing updated successfully');
      return {
        ...state,
        isLoading: false,
        ocpiPartnerPricing: state.ocpiPartnerPricing.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_OCPI_PARTNER_PRICING.SUCCESS: {
      toast.success('OCPI Partner Pricing deleted successfully');
      return {
        ...state,
        ocpiPartnerPricing: state.ocpiPartnerPricing.filter((data) => data.id !== payload),
      };
    }
    case DELETE_OCPI_PARTNER_PRICING.FAIL:
    case UPDATE_OCPI_PARTNER_PRICING.FAIL:
    case FETCH_OCPI_PARTNER_PRICING.FAIL:
    case CREATE_OCPI_PARTNER_PRICING.FAIL:
    case GET_OCPI_PARTNER_PRICING.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default ocpiPartnerPricingReducer;
